exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customer-choose-pharmaceutical .modal-dialog{border-radius:0;max-width:1024px}#customer-choose-pharmaceutical .modal-header{background-color:var(--theme-grey-bg)}#customer-choose-pharmaceutical .modal-content,#customer-choose-pharmaceutical .modal-header{border-radius:0}#customer-choose-pharmaceutical .modal-title{margin:0;text-align:left;font-size:18px}#customer-choose-pharmaceutical .close{top:15px}#customer-choose-pharmaceutical .modal-body{padding:20px}", ""]);

// exports
